import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { StatisticResponseV4 } from "../response/StatisticResponseV4"; // <-- Menggunakan response V4

const API_VERSION = "v4"; // <-- Versi API diubah ke v4

// Interface untuk parameter filter
interface ParamsStatisticV4 {
    property_id: string; // <-- Menambahkan property_id
    start_date?: string;
    end_date?: string;
}

// Interface untuk props hook
interface StatisticDataV4Props {
    filters: ParamsStatisticV4;
}

const useStatisticDataV4 = (query: StatisticDataV4Props) => {
    return useQuery({
        // Query key dibuat unik untuk v4 dan bergantung pada filter
        queryKey: [
            'statistic-v4',
            ...Object.entries(query.filters ?? {})
                .map(([key, value]) => `${key}:${value}`),
        ],
        queryFn: async () => {
            try {
                // Parameter disesuaikan dengan struktur request v4
                const params = {
                    filter: Object.fromEntries(
                        Object.entries(query.filters ?? {}).filter(([_key, value]) => value !== undefined && value !== null && value !== "")
                    ),
                };

                const response = await privateApi.get(`/${API_VERSION}/fos/statistics/overview`, { params });

                // Validasi response menggunakan skema V4
                const validationResult = StatisticResponseV4.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed (V4):", validationResult.error.errors);
                    throw new Error("Invalid Statistic V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Statistic (V4)`, error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
        // Aktifkan hanya jika filter sudah siap
        enabled: !!query.filters.property_id && !!query.filters.start_date && !!query.filters.end_date,
    });
};

export default useStatisticDataV4;